var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"text":"","icon":"","x-small":"","loading":_vm.loading},on:{"click":_vm.toggle}},[_c('img',{staticStyle:{"height":"24px","width":"24px"},attrs:{"src":_vm.imageSource}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }